import { Document, Page, pdfjs } from "react-pdf";
import { Card, VBox } from "./Box";
import { range } from "lodash";
import { ReactNode, useState } from "react";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { isMobileView, pdfWidthMapping } from "../utils/screen";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export type PdfPreviewProps = {
  file: { url: string } | { data: ArrayBuffer | Blob };
  width?: "sm" | "md" | "lg" | number;
  extraContent?: ReactNode;
};

export function PdfPreview({ file, width = "lg", extraContent }: PdfPreviewProps) {
  const [numPages, setNumPages] = useState(0);
  return (
    <Document
      file={"url" in file ? file.url : file.data}
      onLoadSuccess={({ numPages }) => setNumPages(numPages)}
    >
      <VBox gap={"md"}>
        {range(numPages).map((i) => (
          <Card key={i} dropShadow rounded={false} padding={false}>
            <Page
              pageIndex={i}
              scale={typeof width === "number" ? undefined : isMobileView() ? 0.3 : 0.9}
              width={typeof width === "number" ? width : pdfWidthMapping[width]}
            />
          </Card>
        ))}
        {extraContent}
      </VBox>
    </Document>
  );
}
